import { UserResponse } from 'layouts/pages/System/users/services/responses/user.response';

/// Quem pode aparecer no menu de responsável. Sem a ação de atribuir, só ele mesmo e só para lead da fila:
/// é a mesma regra do servidor (LeadAssignRule), que recusa o resto.
export const assignableUsers = (
    users: UserResponse[],
    assignedUserId: string | null | undefined,
    canAssignLeads: boolean,
    userId: string | null
): UserResponse[] => {
    if (canAssignLeads) return users;

    if (assignedUserId || !userId) return [];

    return users.filter((user) => user.id === userId);
};
